import { Box, Avatar, Typography } from '@mui/material'
import { getFirstAndSecondCharacterOnly } from '../../utils/helpers'
import HoverTooltip from '../../components/PageHelpers/HoverTooltip'
import UseTranslation from '../../hooks/UseTranslation'
import { statusDetailsEmployeesListPagination } from '../../redux/features/userBatchStatusDetails/userBatchStatusDetailsThunk'
import Pagination from '../../components/PageHelpers/Pagination'

const EmployeeListContainer = ({ store, customStyle }) => {
  const { t } = UseTranslation()
  return (
    <Box sx={[styles.root, customStyle && customStyle]}>
      {store?.data?.map((user) => (
    <Box sx={styles.singleCard} key={user?.id}>
      <Box>
        <Avatar sx={styles.avatar}>
          {getFirstAndSecondCharacterOnly(user?.username)}
        </Avatar>
      </Box>
      <Box sx={styles.infoContainer}>
        <Box sx={styles.nameUnit}>
          <Typography component='span'>{`${t?.['User Name']}`}</Typography>
          <HoverTooltip title={user?.username || `${t?.['No User Name']}`}>
            <Typography variant='body1'>
              {user?.username || `${t?.['No User Name']}`}
            </Typography>
          </HoverTooltip>
        </Box>
        <Box sx={styles.infoUnit}>
          <Typography component='span'>{`${t?.['E-Mail Address']}`}</Typography>
          <HoverTooltip title={user?.email || '-- -- --'}>
            <Typography variant='body1'>
              {user?.email || '-- -- --'}
            </Typography>
          </HoverTooltip>
        </Box>
        <Box sx={styles.infoUnit}>
          <Typography component='span'>{`${t?.Language}`}</Typography>
          <HoverTooltip title={t?.[user?.language] || '-- -- --'}>
            <Typography variant='body1'>
              {t?.[user?.language] || '-- -- --'}
            </Typography>
          </HoverTooltip>
        </Box>
        <Box sx={styles.infoUnit}>
          <Typography component='span'>{`${t?.Status}`}</Typography>
          <HoverTooltip title={user?.status?.name}>
            <Typography variant='body1'>
              <Box sx={{ color: user?.status?.color }}>{user?.status?.name}</Box>
            </Typography>
          </HoverTooltip>
        </Box>
      </Box>
      </Box>
      ))
      }
       <Pagination
            store={store}
        actionToDispatch={statusDetailsEmployeesListPagination}
        pageSize={50}
      />
    </Box>
  )
}
const styles = {
  singleCard: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'white',
    fontSize: { xs: '14px', md: '16px' },
    padding: { xs: '0 20px 0 5px', md: '0px 20px' },
    margin: '10px',
    borderRadius: '12px',
    boxShadow: '0 1px 3px 0 #efefef, 0 0 0 1px #f1f1f1',
    position: { xs: 'relative', md: 'unset' },
    height: { xs: '100px', md: '110px' },
  },
  avatar: {
    display: 'flex',
    bgcolor: '#FFC542',
    color: 'white',
    height: { xs: '50px', md: '64px' },
    width: { xs: '50px', md: '64px' },
    mr: { xs: '0px', md: '29px' },
    textTransform: 'uppercase',
    fontWeight: 800,
    fontSize: { xs: '16px', md: '25px' },
  },
  infoContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '100%',
    marginLeft: { xs: '10px', md: '0px' },
  },
  nameUnit: {
    display: 'flex',
    flexDirection: { xs: 'row', md: 'column' },
    justifyContent: { xs: 'flex-start', md: 'center' },
    maxWidth: { xs: '90%', sm: '200px', lg: '300px' },
    width: '100%',
    alignItems: 'flex-start',
    '& p': {
      fontSize: { xs: '14px', md: '16px' },
      whiteSpace: { xs: 'nowrap', md: 'nowrap' },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontWeight: { xs: 600, md: 500 },
      width: 'fit-content',
      maxWidth: { xs: '90%', md: '95%' },
    },
    '& span': {
      display: { xs: 'none', md: 'block' },
      width: 'fit-content',
      fontSize: { xs: '14px', md: '16px' },
      opacity: '0.7',
      fontWeight: '500',
      color: 'text.hint',
      marginBottom: '10px',
      marginRight: { xs: '10px', md: '0px' },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: { xs: 'nowrap', md: 'nowrap' },
    },
  },
  infoUnit: {
    display: 'flex',
    flexDirection: { xs: 'row', md: 'column' },
    justifyContent: { xs: 'flex-start', md: 'center' },
    maxWidth: { xs: '90%', sm: '200px', lg: '300px' },
    width: '100%',
    alignItems: 'flex-start',
    '& p': {
      fontSize: { xs: '12px', md: '16px' },
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 'fit-content',
      maxWidth: { xs: '90%', md: '90%' },
    },
    '& span': {
      display: { xs: 'none', md: 'block' },
      width: 'fit-content',
      fontSize: { xs: '12px', md: '14px' },
      opacity: '0.7',
      fontWeight: '500',
      color: 'text.hint',
      marginBottom: '10px',
      marginRight: { xs: '10px', md: '0px' },
    },
  },
}
export default EmployeeListContainer
